
import { put, takeLatest, takeEvery } from "redux-saga/effects";
import axiosCustom from '../../../components/common/apiConfig';
import { handleNotificationAlertTrySelect, handleNotificationAlertCatch } from "../../../components/method/handleNotificationAlert";

export const actionTypes = {
    postSelect: "[postSelect] Action",
    mediaSelect: "[mediaSelect] Action",
    postSelectAsync: "[postSelectAsync] Action",
    mediaSelectAsync: "[mediaSelectAsync] Action",
    postRemove: "[postRemove] Action",
    postLoading: "[postLoading] Action",
};

const initialState = {
    data: {},
    images: {},
    loading: false
};


export const select_post_reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case actionTypes.postSelect:
            return {
                ...state,
                data: {
                
                    [payload?.categories]: payload?.data,
                    ...state?.data,
                },
            }
        case actionTypes.mediaSelect:
          
                let obj = {
            
                    [payload?.id]: {
                        ...state?.data?.[payload?.id],
                        body: payload?.media
                    },
                    ...state?.images,
                }
                    return {
                        ...state,
                        images: obj,
        
                    }
        case actionTypes.postLoading:
            return {
                ...state,
                loading: {
                    ...state?.loading,
                    [payload?.categories]: payload?.data
                },
            }
        case actionTypes.postRemove:
            return initialState
        default:
            return state
    }
}

function* handleWorker({ payload }) {

    yield put({
        type: actionTypes.postLoading, payload: {
            data: true,
            categories: payload?.id
        }
    })

    let config = {
        baseURL: `https://mag.pouyanbroker.com/wp-json/wp/v2/`,
        url: `posts?categories=${payload?.id}`,
        method: "GET",
    }

    let data = {}


    try {
        let res = yield axiosCustom(config, data)

        if (res?.data?.length > 0) {
            let obj = {}
            let x = res?.data?.forEach(element => {
                obj[element?.id] = element
            });

            yield put({ type: actionTypes.postSelect, payload: { data: obj, categories: payload?.id } })
        }


    } catch {
        handleNotificationAlertCatch()
    }
    finally {
        yield put({
            type: actionTypes.postLoading, payload: {
                data: false,
                categories: payload?.id
            }
        })
    }


}
function* handleMediaWorker({ payload }) {

    yield put({ type: actionTypes.postLoading, payload: true })

    let config = {
        baseURL: `https://mag.pouyanbroker.com/wp-json/wp/v2`,
        url: `/media?parent=${payload?.id}`,
        method: "GET",
    }

    let data = {}


    try {
        let res = yield axiosCustom(config, data)


        // let isOk = handleNotificationAlertTrySelect(res)
        // if (!isOk) return

        yield put({ type: actionTypes.mediaSelect, payload: { id: payload?.id, media: res?.data?.[0] ? res?.data?.[0] : {} } })


    } catch {
        handleNotificationAlertCatch()
    }
    finally {
        yield put({ type: actionTypes.postLoading, payload: false })
    }


}


export function* select_post_worker() {

    yield takeEvery(actionTypes.postSelectAsync, handleWorker)
    yield takeEvery(actionTypes.mediaSelectAsync, handleMediaWorker)
}